import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCApiServiceInstance from '@core/services/bpc-api-service.instance';
import { appConfig } from '@/config/app-config';

export type GeoPostalCodeSuggestion = {
  postalCode: string;
  city: string;
  countryCode: string;
  countryName?: string;
};

export class GeoPostalCodeAutocompleteHelper {
  constructor(private $bpcApi: BPCApiServiceInstance, private $routeHelper: BPCApiRouteHelper) {}

  public async getCitiesByPostalCode(
    postalCode: string,
    countryCode?: string | string[],
  ): Promise<GeoPostalCodeSuggestion[]> {
    const path = this.$routeHelper.getApiPath('geo/postal-codes/search');
    const response = await this.$bpcApi
      .get(path, {
        params: {
          postalCode: postalCode,
          countryCode: countryCode,
        },
      })
      .toPromise();
    return response.data;
  }
}

export const useGeoPostalCodeAutocompleteHelper = () => {
  return new GeoPostalCodeAutocompleteHelper(
    new BPCApiServiceInstance({ apiPath: appConfig.apiPathV1 }),
    new BPCApiRouteHelper(),
  );
};
